import { Component, Input } from '@angular/core';
import { PFFormatEmployment } from '../../../../data/interfaces/circle-credit.interface';

@Component({
  selector: 'app-circle-credit-employment-card',
  templateUrl: './circle-credit-employment-card.component.html',
  styleUrls: ['./circle-credit-employment-card.component.scss']
})
export class CircleCreditEmploymentCardComponent {
  @Input() data: PFFormatEmployment | null = null;

  get hasData(): boolean {
    if (!this.data) return false;
    return !!(this.data.companyName || this.data.position || this.data.monthlyIncome);
  }

  get completionPercentage(): number {
    if (!this.data) return 0;
    
    const allFields = ['companyName', 'address', 'city', 'state', 'phoneNumber', 'position', 'hiringDate', 'monthlyIncome', 'paymentFrequency'];
    const filledFields = allFields.filter(field => this.data![field as keyof PFFormatEmployment]);
    return Math.round((filledFields.length / allFields.length) * 100);
  }

  get statusClass(): string {
    if (!this.hasData) return 'status-empty';
    const percentage = this.completionPercentage;
    if (percentage < 30) return 'status-incomplete';
    if (percentage < 70) return 'status-partial';
    return 'status-complete';
  }

  formatCurrency(amount: number | undefined): string {
    if (amount === null || amount === undefined) return 'No especificado';
    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(amount);
  }

  formatDate(date: string | undefined): string {
    if (!date) return 'No especificado';
    try {
      return new Date(date).toLocaleDateString('es-MX');
    } catch {
      return date;
    }
  }
}
